import type {
  FightersTableFilter,
  PaginationModel,
  SortModel,
} from "~/types/players.types";
import {
  SearchPageTabs,
  type GymFilter,
  type OrgFilter,
} from "~/types/search.types";

export const useSearchStore = defineStore("searchStore", {
  state: () => ({
    isFilterOpened: false,
    isFilterAppliedFighters: false,
    isFilterAppliedGyms: false,
    isFilterAppliedOrganisations: false,

    fighterFilter: <FightersTableFilter>{
      name: "",
      country_iso: [],
      gym: {
        selectedIds: [],
        selectedNames: [],
        enabled: true,
      },
      age_from: "",
      age_to: "",
      gender: [],
      martial_art: [],
      martial_art_secondary: [],
      status: [],
      open_to_fight_categories: [],
      total_match_count_from: "",
      total_match_count_to: "",
      total_match_count_pro_from: "",
      total_match_count_pro_to: "",
    },
    fighterSort: <SortModel>{
      column: "name",
      direction: "asc",
    },
    fighterPagination: <PaginationModel>{
      page: 1,
      pageCount: 1,
    },
    gymFilter: <GymFilter>{
      name: "",
      country_iso: [],
      verified: [],
    },
    orgFilter: <OrgFilter>{
      name: "",
      country_iso: [],
      verified: [],
    },
  }),
  getters: {},
  actions: {},
});
